export const statusOptions = [
    { id: 1, value: 'Active' },
    { id: 0, value: 'Inactive' }
];

export const formFields = {
    platform: {
        key: 'platform',
        type: 'text',
        label: 'Platform',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Platform</div>',
        valueKey: 'key',
        textKey: 'value'
    },
    status: {
        key: 'status',
        label: 'Status',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
    },
    accountId: {
        key: 'accountId',
        label: 'Account Id',
        labelLayout: 'col-sm-5',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Account Id</div>',
        valueKey: 'key',
        textKey: 'value'
    },
    subAccountId: {
        key: 'subAccountId',
        label: 'Sub Account Id',
        labelLayout: 'col-sm-8',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Sub Account Id</div>',
        valueKey: 'key',
        textKey: 'value'
    },
};

export const platformConfig = {
    google: "Google Ads",
    beki: "beki",
    ion: "ION",
    meta: "Meta",
    dv360: "DV360",
    tiktok: "TikTok",
};